import React from 'react';
import '../css/components/Card.css';

function Card({nameProject, gifImage, descriptionProject, linkProject}) {
  return (
    <section>
      <a
        className="carousel-link"
        href={ linkProject }
        target="_blank"
        rel="noreferrer"
      >
        <div className="carousel-item">
          <h3
            className="carousel-item-title"
          >
            { nameProject }
          </h3>
          <div
            className="carousel-item-div-image"
          >
            <img
              className="carousel-item-image"
              src={ gifImage }
              alt={ nameProject }
            />
          </div>
          <p
            className="carousel-item-description"
          >
            { descriptionProject }
            </p>
        </div>
      </a>
    </section>
  )
};

export default Card;
